var map = {
	"./BoatLanding": 275,
	"./BoatLanding.tsx": 275,
	"./BoatLandings": 81,
	"./BoatLandings.tsx": 81,
	"./Charters": 2991,
	"./Charters.tsx": 2991,
	"./Error": 6392,
	"./Error.tsx": 6392,
	"./Events": 4350,
	"./Events.tsx": 4350,
	"./FishingSpot": 5390,
	"./FishingSpot.tsx": 5390,
	"./FishingSpots": 4305,
	"./FishingSpots.tsx": 4305,
	"./Home": 545,
	"./Home.tsx": 545,
	"./OffshoreWaveForecast": 385,
	"./OffshoreWaveForecast.tsx": 385,
	"./Privacy": 6995,
	"./Privacy.tsx": 6995,
	"./SolunarCalendar": 8487,
	"./SolunarCalendar.tsx": 8487,
	"./Sponsors": 5890,
	"./Sponsors.tsx": 5890,
	"./Tides": 3849,
	"./Tides.tsx": 3849,
	"./inshore/Charters": 7641,
	"./inshore/Charters.tsx": 7641,
	"./inshore/Reports": 4702,
	"./inshore/Reports.tsx": 4702,
	"./offshore/Charters": 9650,
	"./offshore/Charters.tsx": 9650,
	"./offshore/Reports": 1439,
	"./offshore/Reports.tsx": 1439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1620;
module.exports = webpackContext;